import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles(() => ({
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const ButtonWrapper = ({ children }) => {
  const classes = useStyle();
  return <div className={classes.buttonWrapper}>{children}</div>;
};

ButtonWrapper.propTypes = {
  children: PropTypes.node,
};

export default ButtonWrapper;
